export default __webpack_public_path__ + "static/startup-nest-ceeb84c03233e0c052f472839da94a12.png";